import React from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import DashboardPage from "./components/Dashboard/DashboardPage";
import SuggestionSugPage from "./components/SuggestionSugs/SuggestionSugs";
import DomainsPage from "./components/Domains/DomainsList";
import DomainsItems from "./components/Domains/DomainsItem";
import SousDomainsPage from "./components/SousDomains/SousDomainsList";
import CommissionsPage from "./components/Commissions/CommissionsList";
import RecherchePage from "./components/Recherche/RechercheList";
import RechercheAPage from "./components/Recherche_avance/RechercheList";
import CommissionDomainesPage from "./components/Commissions/CommissionDomainesList";
import FichesPage from "./components/Fiches/FichesList";
import {SuggestionsList as SuggestionsPage} from "./components/suggestions/SuggestionsList";
import FichesAdd from "./components/Fiches/FichesAdd";
import LanguesList from "./components/Langues/LanguesList";
import PaysGeoList from "./components/Pays/PaysGeoList";
import LangageList from "./components/Langage/LangageList";
import FormeVarList from "./components/FormeVar/FormeVarList";
import LoginPage from "./components/Login/LoginPage";
import ChangePasswordPage from "./components/Login/ChangePasswordPage";
import SessionInfo from "./components/Login/SessionInfo";
import DispositifUsersList from "./components/Users/DispositifUsersList";
import { AuthProvider, useAuth } from "./context/AuthContext";
import "@tabler/core/dist/css/tabler.min.css";
import "./styles/admin.css";
import "./styles/roles.css";
// ✅ Tabler JS (optionnel mais utile pour dropdowns, modals, etc.)
import "@tabler/core/dist/js/tabler.min.js";
export default function App() {
  return (
      <AuthProvider>
        <AppShell/>
      </AuthProvider>
  );
}

function AppShell() {
  const { user } = useAuth();
  // "" tant que le rôle n'est pas connu (chargement ou non connecté) : les
  // blocs .role-ce-only restent masqués par défaut jusqu'à confirmation.
  const role = user?.utcRole || "";

  return (
      <BrowserRouter>
        <div data-role={role}>
          <aside className="navbar navbar-vertical navbar-expand-lg" data-bs-theme="dark">
              <div className="container-fluid">
                  <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                          data-bs-target="#sidebar-menu" aria-controls="sidebar-menu" aria-expanded="false"
                          aria-label="Afficher/masquer le menu">
                      <span className="navbar-toggler-icon"></span>
                  </button>
                  <div className="collapse navbar-collapse" id="sidebar-menu">
                          <div className="navbar-brand navbar-brand-autodark">
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;FanceTerme <Link to="/"
                                                                                                        aria-label="Tabler">
                              <svg xmlns="http://www.w3.org/2000/svg" width="110" height="32" viewBox="0 0 232 68"
                                   className="navbar-brand-image">
                                  <path
                                      d="M64.6 16.2C63 9.9 58.1 5 51.8 3.4 40 1.5 28 1.5 16.2 3.4 9.9 5 5 9.9 3.4 16.2 1.5 28 1.5 40 3.4 51.8 5 58.1 9.9 63 16.2 64.6c11.8 1.9 23.8 1.9 35.6 0C58.1 63 63 58.1 64.6 51.8c1.9-11.8 1.9-23.8 0-35.6zM33.3 36.3c-2.8 4.4-6.6 8.2-11.1 11-1.5.9-3.3.9-4.8.1s-2.4-2.3-2.5-4c0-1.7.9-3.3 2.4-4.1 2.3-1.4 4.4-3.2 6.1-5.3-1.8-2.1-3.8-3.8-6.1-5.3-2.3-1.3-3-4.2-1.7-6.4s4.3-2.9 6.5-1.6c4.5 2.8 8.2 6.5 11.1 10.9 1 1.4 1 3.3.1 4.7zM49.2 46H37.8c-2.1 0-3.8-1-3.8-3s1.7-3 3.8-3h11.4c2.1 0 3.8 1 3.8 3s-1.7 3-3.8 3z"
                                      fill="#066fd1"></path>
                              </svg>
                          </Link>
                          </div>
                          <ul className="navbar-nav pt-lg-3">
                              <li className="nav-item">
                                  <Link className="nav-link" to="/">
                  <span className="nav-link-icon d-md-none d-lg-inline-block">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                           className="icon icon-1">
                      <path d="M5 12l-2 0l9 -9l9 9l-2 0"></path>
                      <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"></path>
                      <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6"></path></svg></span>
                                      <span className="nav-link-title"> Accueil </span>
                                  </Link>
                              </li>
                              <li className="nav-item dropdown">
                                  <a className="nav-link dropdown-toggle show" href="#navbar-base"
                                     data-bs-toggle="dropdown" data-bs-auto-close="false" role="button"
                                     aria-expanded="true">
                  <span className="nav-link-icon d-md-none d-lg-inline-block">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                           stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                           className="icon icon-tabler icons-tabler-outline icon-tabler-search">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <path d="M3 10a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
                      <path d="M21 21l-6 -6"></path></svg></span>
                                      <span className="nav-link-title"> Recherche </span>
                                  </a>
                                  <div className="dropdown-menu show" data-bs-popper="static">
                                      <div className="dropdown-menu-columns">
                                          <div className="dropdown-menu-column">
                                              <Link className="dropdown-item" to="/recherche"> Recherche simple </Link>
                                              <Link className="dropdown-item" to="/recherche_avance">
                                                  Recherche avancée <span
                                                  className="badge badge-sm bg-green-lt text-uppercase ms-auto">Nouveau</span>
                                              </Link>
                                          </div>
                                      </div>
                                  </div>
                              </li>
                              <li className="nav-item dropdown role-write-only">
                                  <a className="nav-link dropdown-toggle show" href="#navbar-base"
                                     data-bs-toggle="dropdown" data-bs-auto-close="false" role="button"
                                     aria-expanded="true">
                  <span className="nav-link-icon d-md-none d-lg-inline-block">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                           stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                           className="icon icon-tabler icons-tabler-outline icon-tabler-pencil-cog">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4"></path>
                      <path d="M13.5 6.5l4 4"></path>
                      <path d="M17.001 19a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
                      <path d="M19.001 15.5v1.5"></path>
                      <path d="M19.001 21v1.5"></path>
                      <path d="M22.032 17.25l-1.299 .75"></path>
                      <path d="M17.27 20l-1.3 .75"></path>
                      <path d="M15.97 17.25l1.3 .75"></path>
                      <path d="M20.733 20l1.3 .75"></path></svg></span>
                                      <span className="nav-link-title"> Gestion des termes </span>
                                  </a>
                                  <div className="dropdown-menu show" data-bs-popper="static">
                                      <div className="dropdown-menu-columns">
                                          <div className="dropdown-menu-column">
                                              <Link className="dropdown-item" to="/creation_fiche"> Nouveau terme <span
                                                  className="badge badge-sm bg-green-lt text-uppercase ms-auto">Nouveau</span></Link>
                                              <Link className="dropdown-item" to="/creation_fiche.html?istoponyme=true">
                                                  Nouveau toponyme
                                              </Link>
                                          </div>
                                      </div>
                                  </div>
                              </li>
                              <li className="nav-item dropdown">
                                  <a className="nav-link dropdown-toggle show" href="#navbar-base"
                                     data-bs-toggle="dropdown" data-bs-auto-close="false" role="button"
                                     aria-expanded="true">
                  <span className="nav-link-icon d-md-none d-lg-inline-block">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                           stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                           className="icon icon-tabler icons-tabler-outline icon-tabler-message-user">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <path d="M13 18l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5"></path>
                      <path d="M17 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
                      <path d="M22 22a2 2 0 0 0 -2 -2h-2a2 2 0 0 0 -2 2"></path></svg></span>
                                      <span className="nav-link-title"> Suggestions </span>
                                  </a>
                                  <div className="dropdown-menu show" data-bs-popper="static">
                                      <div className="dropdown-menu-columns">
                                          <div className="dropdown-menu-column">
                                              <Link className="dropdown-item" to="/suggestions"> Liste des
                                                  suggestions </Link>
                                          </div>
                                      </div>
                                  </div>
                              </li>
                              <li className="nav-item dropdown role-ce-only">
                                  <a className="nav-link dropdown-toggle show" href="#navbar-base"
                                     data-bs-toggle="dropdown" data-bs-auto-close="false" role="button"
                                     aria-expanded="true">
                  <span className="nav-link-icon d-md-none d-lg-inline-block">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                           stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                           className="icon icon-tabler icons-tabler-outline icon-tabler-settings">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <path
                          d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065"></path>
                      <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"></path></svg></span>
                                      <span className="nav-link-title"> Administration </span>
                                  </a>
                                  <div className="dropdown-menu show" data-bs-popper="static">
                                      <div className="dropdown-menu-columns">
                                          <div className="dropdown-menu-column">
                                              <Link className="dropdown-item" to="/commissions">
                                                  Gestion des collèges
                                              </Link>
                                              <Link className="dropdown-item" to="/domains">
                                                  Gestion des domaines
                                              </Link>
                                              <Link className="dropdown-item" to="/sous_domains">
                                                  Gestion des sous-domaines
                                              </Link>
                                              <Link className="dropdown-item" to="/langues">
                                                  Gestion des codes langue
                                              </Link>
                                              <Link className="dropdown-item" to="/pays">
                                                  Gestion des origines géographiques
                                              </Link>
                                              <Link className="dropdown-item" to="/niveaux_langue">
                                                  Gestion des niveaux de langue
                                              </Link>
                                              <Link className="dropdown-item" to="/types_variante">
                                                  Gestion des types de variante
                                              </Link>
                                              <Link className="dropdown-item" to="/users/dispositif">
                                                  Gestion des utilisateurs "Dispositif"
                                              </Link>
                                          </div>
                                      </div>
                                  </div>
                              </li>
                          </ul>
                          <SessionInfo/>
                      </div>
                  </div>
              </aside>
              <div className="page-wrapper">
                  <div className="page-body">
                      <div className="container-xl">
                          <Routes>
                              <Route path="/" element={<DashboardPage/>}/>
                              <Route path="/login" element={<LoginPage/>}/>
                              <Route path="/changer-mot-de-passe" element={<ChangePasswordPage/>}/>
                              <Route path="/recherche" element={<RecherchePage/>}/>
                              <Route path="/recherche_avance" element={<RechercheAPage/>}/>
                              <Route path="/suggestion_sugs" element={<SuggestionSugPage/>}/>
                              <Route path="/domains" element={<DomainsPage/>}/>
                              <Route path="/domains/:id" element={<DomainsItems/>}/>
                              <Route path="/sous_domains" element={<SousDomainsPage/>}/>
                              <Route path="/commissions" element={<CommissionsPage/>}/>
                              <Route path="/commissions/:id/domaines" element={<CommissionDomainesPage/>}/>
                              <Route path="/fiches" element={<FichesPage/>}/>
                              <Route path="/suggestions" element={<SuggestionsPage/>}/>
                              {/*<Route path="/nouvelle_suggestion" element={<SuggestionsAddPage/>}/>*/}
                              <Route path="/creation_fiche" element={<FichesAdd/>}/>
                              <Route path="/creation_fiche/:id" element={<FichesAdd/>}/>
                              <Route path="/langues" element={<LanguesList/>}/>
                              <Route path="/pays" element={<PaysGeoList/>}/>
                              <Route path="/niveaux_langue" element={<LangageList/>}/>
                              <Route path="/types_variante" element={<FormeVarList/>}/>
                              <Route path="/users/dispositif" element={<DispositifUsersList/>}/>
                          </Routes>
                      </div>
                  </div>
              </div>
        </div>
      </BrowserRouter>
  );
}
